import React, { Component } from "react";

import BigCalendar from "react-big-calendar";
import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";
import Popup from "reactjs-popup";
import Moment from 'react-moment';
import { Link } from 'react-router-dom'
import Flags from './Flags'

moment.locale('en-gb');

class Calendar extends Component {
  constructor(props, context) {
    super(props, context);

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);

    this.state = {
      showModal: false,
      popupEvent: {}
    };
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal(event) {
    this.setState({ showModal: true, popupEvent: event });
  }

  localizer = BigCalendar.momentLocalizer(moment);
  allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);
  state = { view: "week" };

  propGetter(event, start, end, isSelected) {
    let classes = [event.booking_from]
    if (!event.item.tcs_assigned_to) { classes.push('unassigned') }
    return { className: classes.join(' ') };
  }

  viewChanged(view, date) {
    let begin, end
    switch (view) {
      case 'day':
        begin = moment(date).startOf('day')
        end = moment(date).endOf('day')
        break
      case 'week':
        begin = moment(date).startOf('isoWeek')
        end = moment(date).endOf('isoWeek')
        break
      case 'month':
        begin = moment(date).startOf('month').subtract(7, 'days')
        end = moment(date).endOf('month').add(7, 'days')
        break
      case 'agenda':
        begin = moment(date).startOf('day')
        end = moment(date).endOf('day').add(1, 'month')
        break
      default:
        console.log('unknown view')
    }
    this.setState({ begin: begin, end: end, view: view })
    this.props.dateRangeChanged(begin, end)
  }

  render() {
    const EventAgenda = ({ event }) => {
      return (
        <span>
          <div className='row'>
            <div className='col-sm-6'><em><strong>{event.title}</strong></em> {event.flags.includes('tcs_attendee_confirmed') && <span>(confirmed attendee)</span>}</div>
            <div className='col-sm-6'><Link to={`/m1/deals/${event.id}`}>go to Deal page</Link></div>
          </div>
          <div className='row'>
            <div className='col-sm-6'>
              <div className='row'>
              <div className='col-sm-4'>Parent name</div><div className='col-sm-5'>{event.first_name}</div>
              <div className='col-sm-4'>Mobile</div><div className='col-sm-5'>{event.mobile}</div>
              <div className='col-sm-4'>Student name</div><div className='col-sm-5'>{event.student_first_name}</div>
              </div>
            </div>
            <div className='col-sm-6'>
              <div className='row'>
                <div className='col-sm-4'>Assigned to</div><div className='col-sm-5'>{event.tcs_assigned_to || 'unassigned'}</div>
                <div className='col-sm-4'>Booking from</div><div className='col-sm-5'>{event.booking_from}</div>
                <div className='col-sm-4'>Business stream</div><div className='col-sm-5'>{event.business_stream}</div>
                <div className='col-sm-4'>Deal</div><div className='col-sm-5'></div>
              </div>
            </div>
          </div>
        </span>
      )
    }
    const Event = ({ event }) => {
      return (
        <span>
          {event.item.flags.includes('tcs_attendee_confirmed') && <i className="fas fa-star" aria-hidden="true" style={{ color: '#fffd6c', fontSize: 16, marginRight: 3 }}></i>}
          {event.title}
        </span>
      )
    }

    const { popupEvent } = this.state;
    return (
      <div style={{ height: "70vh" }}>
        <BigCalendar
          min={new Date(2016, 10, 0, 8, 0, 0)}
          localizer={this.localizer}
          events={this.props.events}
          startAccessor="start"
          endAccessor="end"
          step={60}
          timeslots={1}
          showMultiDayTimes
          views={["month", "week", "day", "agenda"]}
          view={this.state.view}
          onView={(view) => { this.viewChanged(view) }}
          onSelectEvent={(event, e) => { this.openModal(event) }}
          onNavigate={(date, view) => { this.viewChanged(view, date) }}
          tooltipAccessor="tooltip"
          eventPropGetter={this.propGetter}
          components={{
            event: Event,
            week: {
              event: Event
            },
            agenda: {
              event: EventAgenda,
            }
          }}
        />

        <Popup
          open={this.state.showModal}
          closeOnDocumentClick
          onClose={this.closeModal}
        >
          <div>
            <button className="close" onClick={this.closeModal} style={{ color: '#0056ff', fontSize: '30px', position: 'absolute', top: '5px', right: '12px' }}>
              &times;
            </button>
            <div style={{ padding: '20px', fontSize: '20px' }}>
              <div>
                <Flags deal={popupEvent} />
              </div>
              <div className='row'>
                <div className='col-sm-4'>Time</div>
                <div className='col-sm-4'><Moment format="hh:mma MMM Do YYYY">{popupEvent.tcs_at}</Moment></div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Parent Name</div>
                <div className='col-sm-4'>{popupEvent.first_name}</div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Email</div>
                <div className='col-sm-4'>{popupEvent.email}</div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Mobile</div>
                <div className='col-sm-4'>{popupEvent.mobile}</div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Student Name</div>
                <div className='col-sm-4'>{popupEvent.student_first_name}</div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Assigned To</div>
                <div className='col-sm-4'>{popupEvent.tcs_assigned_to || 'unassigned'}</div>
              </div>
              <div className='row'>
                <div className='col-sm-4'>Booking From</div>
                <div className='col-sm-4'>{popupEvent.booking_from}</div>
              </div>
              <hr />
              <div style={{ marginTop: '6px' }}>
                <Link to={`/m1/deals/${popupEvent.id}`}>go to Deal page</Link>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}

export default Calendar;
